/**
 * CategoryBadgesRow Component
 *
 * Displays all category badges for a response in a compact horizontal scroll rail.
 * Shows individual criterion scores with emoji icons.
 */

import React from 'react';
import { CategoryBadge } from './CategoryBadge';

export interface CategoryBadgesRowProps {
  scores: { [criterion: string]: number };
  size?: 'xs' | 'sm';
}

export const CategoryBadgesRow: React.FC<CategoryBadgesRowProps> = ({
  scores,
  size = 'xs',
}) => {
  // Convert scores object to sorted array of [criterion, score] entries
  const sortedScores = Object.entries(scores).sort(([a], [b]) =>
    a.localeCompare(b)
  );

  if (sortedScores.length === 0) {
    return null;
  }

  return (
    <div
      className="flex flex-nowrap items-center gap-1.5 overflow-x-auto pb-1 scrollbar-thin scrollbar-thumb-slate-700 scrollbar-track-transparent"
      role="list"
      aria-label="Category scores"
    >
      {sortedScores.map(([criterion, score]) => (
        <div key={criterion} role="listitem">
          <CategoryBadge criterion={criterion} score={score} size={size} />
        </div>
      ))}
    </div>
  );
};
